/* Pulmur quick-add: makes product-card "Add to Cart" (homepage, collection,
   cross-sell) and the cart-drawer upsell "Add" buttons add via AJAX and open
   the Pulmur cart drawer, instead of navigating to the /cart page. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function setBadge(count) {
    if (count == null) return;
    var icon = document.getElementById('cart-icon-bubble');
    var badge = icon ? icon.querySelector('.pulmur-cart-badge') : document.querySelector('.pulmur-cart-badge');
    if (count <= 0) { if (badge) badge.remove(); return; }
    if (badge) {
      badge.textContent = count > 99 ? 99 : count;
    } else if (icon) {
      badge = document.createElement('span');
      badge.className = 'pulmur-cart-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = count > 99 ? 99 : count;
      icon.insertBefore(badge, icon.querySelector('.visually-hidden') || null);
    }
  }

  function refreshAndOpenDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { window.location = root + 'cart'; return; }
    fetch(root + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
          var current = document.querySelector('#CartDrawer');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        drawer.classList.remove('is-empty');
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        var cnt = document.querySelector('#CartDrawer .pulmur-cart__item-count');
        if (cnt) { var m = cnt.textContent.match(/\d+/); if (m) setBadge(parseInt(m[0], 10)); }

        if (typeof drawer.open === 'function') drawer.open();
        else drawer.classList.add('animate', 'active');
      })
      .catch(function () { window.location = root + 'cart'; });
  }

  function addToCart(id, qty, btn) {
    if (!id) return;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '0.6'; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; }
        if (!res.ok) { if (res.d && res.d.description) window.alert(res.d.description); return; }
        refreshAndOpenDrawer();
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; }
        window.location = root + 'cart';
      });
  }

  /* Product-card Add to Cart forms */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.pulmur-pc__form');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('[name="id"]');
    if (input) addToCart(input.value, 1, form.querySelector('.pulmur-pc__atc'));
  });

  /* Cart-drawer upsell "Add" buttons */
  document.addEventListener('click', function (e) {
    var up = e.target.closest && e.target.closest('.pulmur-cart__upsell-add');
    if (!up) return;
    e.preventDefault();
    addToCart(up.getAttribute('data-variant-id'), 1, up);
  });
})();
